// Every Workix account signed in from this browser, as the extension keeps them per machine,
// and which one is in use. Their tokens are the source servers', so they are kept apart from
// this installation's own session. An account is { id, apiUrl, email, token }.
const ACCOUNTS_KEY = "sync_accounts";
const ACTIVE_ACCOUNT_KEY = "sync_active_account";

// The account selector's last option: not an account, the way to add one.
const NEW_ACCOUNT = "new";

const readAccounts = () => JSON.parse(localStorage.getItem(ACCOUNTS_KEY)) || [];

const readActiveAccount = () =>
  readAccounts().find((account) => account.id == localStorage.getItem(ACTIVE_ACCOUNT_KEY));

// A synced flow is checked and updated with the account in use when it is on the flow's
// server, and with any other account saved for that server otherwise.
const readAccountFor = (apiUrl) => {
  const active = readActiveAccount();
  if (active && active.apiUrl == apiUrl) return active;
  return readAccounts().find((account) => account.apiUrl == apiUrl);
};

const saveAccount = (apiUrl, email, token) => {
  const account = { id: `${apiUrl}|${email}`, apiUrl, email, token };
  writeAccounts([...readAccounts().filter((saved) => saved.id != account.id), account]);
  selectAccount(account.id);
  return account;
};

const selectAccount = (accountId) => localStorage.setItem(ACTIVE_ACCOUNT_KEY, accountId);

const removeAccount = (accountId) => {
  writeAccounts(readAccounts().filter((account) => account.id != accountId));
  localStorage.removeItem(ACTIVE_ACCOUNT_KEY);
};

// One group per server, so the same email on two servers stays apart.
const groupAccountsByServer = (accounts) => {
  const groups = {};
  for (const account of accounts) {
    groups[account.apiUrl] = [...(groups[account.apiUrl] || []), account];
  }
  return Object.entries(groups).map(([apiUrl, grouped]) => ({ apiUrl, accounts: grouped }));
};

const writeAccounts = (accounts) => localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(accounts));

export { NEW_ACCOUNT, readAccounts, readActiveAccount, readAccountFor, saveAccount, selectAccount, removeAccount, groupAccountsByServer };
